var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{ref:"dataTable",staticClass:"custom-select-table",attrs:{"dense":"","headers":_vm.computedHeaders,"items":_vm.computedRecords,"single-select":_vm.singleSelect,"item-key":"id","show-select":"","items-per-page":15},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }